import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Curriculum/Curriculum.css";
import { curriculumData } from "../../Data/Data";

const Curriculum = () => {

  const renderBlock = (block) => {

    switch (block.type) {

      case "list":
        return (
          <div className="block">
            <h6>{block.heading}</h6>
            <ul>
              {block.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        );

      case "text":
        return <p className="text-muted">{block.content}</p>;

      case "highlight":
        return <p className="highlight">{block.content}</p>;

      case "grid":
        return (
          <div className="row">
            {block.columns.map((col, i) => (
              <div className="col-md-4 col-12" key={i}>
                <div className="stream-box">
                  <h6>{col.title}</h6>
                  <ul>
                    {col.items.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <section className="curriculum-section">
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-title">ACADEMIC CURRICULUM</h2>
          <p className="subtitle">ICSE & ISC Pattern | English Medium</p>
        </div>

        {/* LOOP ALL DATA */}
        {curriculumData.map((sec, index) => {

          if (sec.section === "intro") {
            return (
              <div className="intro-glass mb-5" key={index}>
                {sec.content}
              </div>
            );
          }

          if (sec.section === "classGroup") {
            return (
              <div className="curriculum-card mb-5" key={index}>
                <h4 className="card-title">{sec.title}</h4>

                {sec.blocks.map((block, i) => (
                  <div key={i}>{renderBlock(block)}</div>
                ))}
              </div>
            );
          }

          if (sec.section === "info") {
            return (
              <div className="info-card mb-4" key={index}>
                <h5>{sec.title}</h5>
                <ul>
                  {sec.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            );
          }

          return null;
        })}

      </div>
    </section>
  );
};

export default Curriculum;